import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import { productId, productSubcategory, productType } from '~/lib/tealium/lookups';
import { loanTypes } from '~/constants/loanTypes';
import { pageNames } from '~/constants/pageNames';

const getPageName = (state) => {
  const offerId = get(state, 'displayData.globalData.offerId');
  const submitFrom = get(state, 'ui.submitFrom');
  const selectedLoanOption = isNumber(get(state, 'displayData.loanAmountIndex')) && get(state, `displayData.loanOffer.loanOptions[${state.displayData.loanAmountIndex}]`);
  const folio = get(state, 'displayData.folio');

  let productId_lookup = productId[offerId];
  let productSubcategory_lookup = productSubcategory[offerId];
  let productType_lookup = productType[offerId];

  const getFunnelStepsForProcessing = (submitFrom) => {
    switch (submitFrom) {
      case pageNames.loanReview:
        return (productType_lookup === loanTypes.immediate || productType_lookup === loanTypes.refill) ? '4' : '2';
      default:
        return '2';
    }
  };

  return {
    enterAmount: {
      error_type: '',
      funnel_step: '1',
      funnel_step_name: 'enter amount',
      page_category: 'offers',
      page_name: 'ib:offers:enter amount',
      page_subcategory: 'enter amount',
      page_type: 'application',
      page_url: '/offers/enter-amount',
      product_category: 'loans',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
    },
    loanReview: {
      error_type: '',
      funnel_step: productType_lookup === loanTypes.immediate || productType_lookup === loanTypes.refill ? '3' : '1',
      funnel_step_name: 'loans',
      page_category: 'offers',
      page_name: 'ib:offers:loans',
      page_subcategory: 'loans',
      page_type: 'application',
      page_url: '/offers/loans',
      product_category: 'loans',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
    },
    processing: {
      error_type: '',
      funnel_step: getFunnelStepsForProcessing(submitFrom),
      funnel_step_name: submitFrom === pageNames.enterAmount ? 'processing to loans' : 'processing to confirmation',
      page_category: 'offers',
      page_name: submitFrom === pageNames.enterAmount ? 'ib:offers:loans:processing to loans' : 'ib:offers:loans:processing to confirmation',
      page_subcategory: 'loans',
      page_type: submitFrom === pageNames.enterAmount ? 'application': 'other',
      page_url: submitFrom === pageNames.enterAmount ? '/offers/loans/processing-to-loans' : '/offers/loans/processing-to-confirmation',
      product_category: 'loans',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
      start_amount: submitFrom === pageNames.enterAmount ? get(state, 'displayData.requestedAmount') : '',
    },
    loanSuccess: {
      application_decision: 'completed',
      application_id: folio,
      error_type: '',
      funnel_step: productType_lookup === loanTypes.immediate || productType_lookup === loanTypes.refill ? '5' : '3',
      funnel_step_name: 'confirmation',
      page_category: 'offers',
      page_name: 'ib:offers:loans:confirmation',
      page_subcategory: 'loans',
      page_type: 'application',
      page_url: '/offers/loans/confirmation',
      product_category: 'loans',
      product_subcategory: productSubcategory_lookup,
      product_id: productId_lookup,
      amount: get(selectedLoanOption, 'principal.amount'),
      term: get(selectedLoanOption, 'term.length'),
      interest_rate: get(selectedLoanOption, 'interestRate'),
    },
    errorPage: {
      error_type: 'application',
      funnel_step: '',
      funnel_step_name: '',
      page_category: 'offers',
      page_name: 'ib:offers:loans:technical error',
      page_subcategory: 'loans',
      page_type: 'error',
      page_url: '/offers/loans/technical-error',
      product_category: '',
      product_subcategory: '',
      product_id: '',
    },
  };
};

const getPageData = (trackingPage, state) => {
  return {
    ...get(getPageName(state), trackingPage),
  };
};

export default getPageData;
